var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"title",rawName:"v-title"}],attrs:{"data-title":"询价文件管理系统","id":"app"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }